import $ from 'cash-dom'
import _ from 'lodash'
import Handlebars from 'handlebars'
import {gsap} from 'gsap'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'
import {Fancybox} from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
import {Carousel} from '@fancyapps/ui/dist/carousel/carousel.esm.js'
import '@fancyapps/ui/dist/carousel/carousel.css'
import {Autoplay} from '@fancyapps/ui/dist/carousel/carousel.autoplay.esm.js'
import '@fancyapps/ui/dist/carousel/carousel.autoplay.css'
import wxShare from './wx-share.js'
import data from './data.js'
import 'normalize.css'
import share from '../images/share.jpg'
import logo from 'bundle-text:../images/logo.svg'

gsap.registerPlugin(ScrollToPlugin)

wxShare(location.href, '王谢堂燕', '新时代最好的旧文人', share)

$('.m-cover').on('click', '.foreword-btn', function() {
  Fancybox.show([
    {
      src: '#foreword',
      type: 'clone'
    }
  ], {
    autoFocus: false
  })
})
$('.m-cover').on('click', '.one', function() {
  gsap.to(window, {
    scrollTo: '.m-h1-home',
    duration: 1
  })
})
$('.m-cover').on('click', '.two', function() {
  gsap.to(window, {
    scrollTo: '.m-h1-sight',
    duration: 1
  })
})
$('.m-cover').on('click', '.three', function() {
  gsap.to(window, {
    scrollTo: '.m-h1-life',
    duration: 1
  })
})
$('.m-cover').on('click', '.four', function() {
  gsap.to(window, {
    scrollTo: '.m-h1-pen',
    duration: 1
  })
})
$('.m-h1').on('click', '.to-top-btn', function() {
  gsap.to(window, {
    scrollTo: 0,
    duration: 1
  })
})

const slideTemplate = Handlebars.compile($('#slide-template').html())
function slide(type, target) {
  $(slideTemplate(_.pickBy(data, function(v, k) {
    return _.startsWith(k, type)
  }))).insertAfter(target)
}

slide('life1', '#slide-title-life1')
slide('life2', '#slide-title-life2')
slide('life3', '#slide-title-life3')
slide('life4', '#slide-title-life4')

slide('pen1', '#slide-intro-pen1')
slide('pen2', '#slide-intro-pen2')

$('.f-carousel').each(function(i, el) {
  new Carousel(el, {
    Dots: false,
    Navigation: false,
    Autoplay: {
      showProgress: false,
      timeout: 5000
    }
  }, {
    Autoplay
  })
})

$('.f-carousel').on('click', '.m-image', function(e) {
  new Fancybox([
    {
      src: 'collection.html#' + $(e.target).data('id'),
      type: 'iframe'
    }
  ], {
    Html: {
      autoSize: false
    }
  })
})

$('.m-logo').html(logo)
